export default {
  sections: {
    folders: 'Carpetas',
    programs: 'Programas educativos',
    resources: 'Recursos'
  },
  seeMore: 'Ver más'
}

export const en = {
  sections: {
    folders: 'Folders',
    programs: 'Educational programs',
    resources: 'Resources'
  },
  seeMore: 'See more'
}

export const ca = {
  sections: {
    folders: 'Carpetes',
    programs: 'Programes educatius',
    resources: 'Recursos'
  },
  seeMore: 'Veure més'
}
